module.exports = __webpack_public_path__ + "static/media/cv.ace21176.pdf";